import { QuestionnaireHistoryItem } from '../interfaces/Questionnaire/IQuestionnaireHistory';

function readNestedValue(
  source: Record<string, unknown> | null | undefined,
  path: string[]
): unknown {
  let current: unknown = source;

  for (const segment of path) {
    if (!current || typeof current !== 'object') {
      return undefined;
    }

    current = (current as Record<string, unknown>)[segment];
  }

  return current;
}

function firstString(...values: unknown[]): string | undefined {
  for (const value of values) {
    if (typeof value === 'string' && value.trim()) {
      return value.trim();
    }
  }

  return undefined;
}

export function getQuestionnaireActorLookupId(
  item: QuestionnaireHistoryItem
): string | undefined {
  const submission =
    item.submission && typeof item.submission === 'object'
      ? (item.submission as Record<string, unknown>)
      : null;
  const answers =
    item.answers && typeof item.answers === 'object'
      ? (item.answers as Record<string, unknown>)
      : null;

  return firstString(
    readNestedValue(item.submittedBy as Record<string, unknown>, ['userId']),
    readNestedValue(item.createdBy as Record<string, unknown>, ['userId']),
    item.submittedBy,
    item.createdBy,
    readNestedValue(answers, ['userId']),
    readNestedValue(answers, ['createdByUserId']),
    readNestedValue(answers, ['submittedByUserId']),
    readNestedValue(answers, ['createdBy']),
    readNestedValue(answers, ['submittedBy']),
    readNestedValue(submission, ['submittedByUserId']),
    readNestedValue(submission, ['createdByUserId']),
    readNestedValue(submission, ['submittedById']),
    readNestedValue(submission, ['createdById']),
    readNestedValue(submission, ['submittedBy', 'id']),
    readNestedValue(submission, ['createdBy', 'id']),
    readNestedValue(submission, ['submittedBy', 'userId']),
    readNestedValue(submission, ['createdBy', 'userId'])
  );
}

export function getQuestionnaireActorDisplayValue(
  item: QuestionnaireHistoryItem,
  resolvedUserName?: string
): string {
  const submission =
    item.submission && typeof item.submission === 'object'
      ? (item.submission as Record<string, unknown>)
      : null;
  const answers =
    item.answers && typeof item.answers === 'object'
      ? (item.answers as Record<string, unknown>)
      : null;

  return (
    firstString(
      readNestedValue(item.submittedBy as Record<string, unknown>, ['displayName']),
      readNestedValue(item.submittedBy as Record<string, unknown>, ['username']),
      readNestedValue(item.createdBy as Record<string, unknown>, ['displayName']),
      readNestedValue(item.createdBy as Record<string, unknown>, ['username']),
      item.submittedByName,
      item.submittedByUserName,
      readNestedValue(answers, ['displayName']),
      readNestedValue(answers, ['fullName']),
      readNestedValue(answers, ['username']),
      readNestedValue(submission, ['submittedByName']),
      readNestedValue(submission, ['submittedByDisplayName']),
      readNestedValue(submission, ['submittedByFullName']),
      readNestedValue(submission, ['submittedByUserName']),
      readNestedValue(submission, ['submittedByUsername']),
      readNestedValue(submission, ['submittedBy', 'fullName']),
      readNestedValue(submission, ['submittedBy', 'displayName']),
      readNestedValue(submission, ['submittedBy', 'username']),
      item.createdByName,
      item.createdByUserName,
      readNestedValue(submission, ['createdByName']),
      readNestedValue(submission, ['createdByDisplayName']),
      readNestedValue(submission, ['createdByFullName']),
      readNestedValue(submission, ['createdByUserName']),
      readNestedValue(submission, ['createdByUsername']),
      readNestedValue(submission, ['createdBy', 'fullName']),
      readNestedValue(submission, ['createdBy', 'displayName']),
      readNestedValue(submission, ['createdBy', 'username']),
      resolvedUserName,
      getQuestionnaireActorLookupId(item)
    ) ?? 'N/A'
  );
}
